module.exports = __webpack_public_path__ + "img/none.e1195b15.svg";